import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yearsOfService',
})
export class YearsOfServicePipe implements PipeTransform {
  transform(hireDate: string | undefined | null): string | null {
    if (!hireDate) {
      return null;
    }

    const start = new Date(hireDate);
    if (Number.isNaN(start.getTime())) {
      return null;
    }

    const now = new Date();
    if (start > now) {
      return null;
    }

    if (this._isSameCalendarDay(start, now)) {
      return null;
    }

    const totalMonths =
      (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
    if (totalMonths < 0) {
      return null;
    }

    if (totalMonths === 0) {
      const days = this._daysBetweenStartOfDay(start, now);
      return `В команде: ${days} ${this._pluralDays(days)}`;
    }

    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    const yearWord = this._pluralYears(years);
    const monthWord = this._pluralMonths(months);

    if (years === 0) {
      return `В команде: ${months} ${monthWord}`;
    }

    if (months === 0) {
      return `В команде: ${years} ${yearWord}`;
    }

    return `В команде: ${years} ${yearWord} ${months} ${monthWord}`;
  }

  private _isSameCalendarDay(firstDate: Date, secondDate: Date): boolean {
    return (
      firstDate.getFullYear() === secondDate.getFullYear() &&
      firstDate.getMonth() === secondDate.getMonth() &&
      firstDate.getDate() === secondDate.getDate()
    );
  }

  private _daysBetweenStartOfDay(fromDate: Date, toDate: Date): number {
    const fromDateStart = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    const toDateStart = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
    return Math.round((toDateStart.getTime() - fromDateStart.getTime()) / (24 * 60 * 60 * 1000));
  }

  private _pluralDays(count: number): string {
    if (count % 10 === 1 && count % 100 !== 11) {
      return 'день';
    }

    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
      return 'дня';
    }

    return 'дней';
  }

  private _pluralYears(count: number): string {
    if (count % 10 === 1 && count % 100 !== 11) {
      return 'год';
    }

    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
      return 'года';
    }

    return 'лет';
  }

  private _pluralMonths(count: number): string {
    if (count % 10 === 1 && count % 100 !== 11) {
      return 'месяц';
    }

    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
      return 'месяца';
    }

    return 'месяцев';
  }
}
